export default {
  async setup(appStore) {
    const urlParams = new URLSearchParams(globalThis.location.search)
    const token = urlParams.get('token')
    const nonce = urlParams.get('nonce')

    if (token) {
      try {
        await appStore.auth.exchangeToken(token, nonce)
        const url = new URL(globalThis.location.href)
        url.searchParams.delete('token')
        url.searchParams.delete('nonce')
        globalThis.history.replaceState({}, '', url.toString())
      } catch (error) {
        console.error('Failed to exchange SSO token:', error)
      }
    }

    if (!appStore.auth.isSignedIn) {
      try {
        await appStore.auth.revalidateLogin()
      } catch (error) {
        // If revalidation fails, continue with app startup
        // The user will see the login UI instead of a blank page
        console.warn('Failed to revalidate login:', error)
      }
    }
  },
}
